angular.module('tenantBilling').filter('aqConsumption', ($filter) => {
    return (consumption, serviceType) => {
        const format = serviceType === 'STEAM' ? '0,0.00' : '0,0';
        return $filter('aqnumber')(consumption, format);
    };
});
